import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
import get from 'lodash/get';

export const GET_SURVEY_PAGE_REQUEST = 'GET_SURVEY_PAGE_REQUEST';
export const GET_SURVEY_PAGE_SUCCESS = 'GET_SURVEY_PAGE_SUCCESS';
export const GET_SURVEY_PAGE_ERROR = 'GET_SURVEY_PAGE_ERROR';

export const SURVEY_SAVE_REQUEST = 'SURVEY_SAVE_REQUEST';
export const SURVEY_SAVE_SUCCESS = 'SURVEY_SAVE_SUCCESS';
export const SURVEY_SAVE_ERROR = 'SURVEY_SAVE_ERROR';

export const SURVEY_COMPLETE_REQUEST = 'SURVEY_COMPLETE_REQUEST';
export const SURVEY_COMPLETE_SUCCESS = 'SURVEY_COMPLETE_SUCCESS';
export const SURVEY_COMPLETE_ERROR = 'SURVEY_COMPLETE_ERROR';

export const SURVEY_GO_NEXT = 'SURVEY_GO_NEXT';
export const SURVEY_GO_PREV = 'SURVEY_GO_PREV';

export function goNextQuestionAction() {
	return dispatch => {
		dispatch({ type: SURVEY_GO_NEXT });
	};
}

export function goPrevQuestionAction() {
	return dispatch => {
		dispatch({ type: SURVEY_GO_PREV });
	};
}

function getSurveyPageRequestAction() {
	return { type: GET_SURVEY_PAGE_REQUEST };
}

function getSurveyPageSuccessAction(data) {
	return { type: GET_SURVEY_PAGE_SUCCESS, data };
}

function getSurveyPageErrorAction(error) {
	return { type: GET_SURVEY_PAGE_ERROR, error };
}

export function fetchSurveyPageAction(requestParams) {
	return dispatch => {
		dispatch(getSurveyPageRequestAction());
		const requestQuery = {
			id: requestParams.surveyId,
			ref_id: requestParams.refId ? encodeURIComponent(requestParams.refId) : null,
			order_id: requestParams.orderId ? encodeURIComponent(requestParams.orderId) : null,
			page: 1,
			channel: 'website',
			platform: 'desktop',
			ts: requestParams.ts,
			accountId: requestParams.secAccId ? encodeURIComponent(requestParams.secAccId) : null,
			secReturnId: requestParams.secReturnId ? encodeURIComponent(requestParams.secReturnId) : null,
			listingId: requestParams.listingId ? requestParams.listingId : null
		};
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/survey',
				query: requestQuery
			})
		).then(
			json => {
				const statusCode = get(json['RESPONSE'], ['surveyData', 'survey_status_code', 'statusCode']);
				if (statusCode && statusCode === 401) {
					dispatch(getSurveyPageErrorAction(statusCode));
				} else {
					dispatch(getSurveyPageSuccessAction(json['RESPONSE']));
				}
			},
			err => {
				dispatch(getSurveyPageErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

function surveySaveRequestAction() {
	return { type: SURVEY_SAVE_REQUEST };
}

function surveySaveSuccessAction(data) {
	return { type: SURVEY_SAVE_SUCCESS, data };
}

function surveySaveErrorAction(error) {
	return { type: SURVEY_SAVE_ERROR, error };
}

export function saveSurveyAction({ surveyId, refId, orderId, responses, initialResponse, secAccId, ts, secReturnId }) {
	return dispatch => {
		dispatch(surveySaveRequestAction());
		const payload = {
			channel: 'website',
			page: '1',
			platform: 'desktop',
			ref_id: refId,
			responses: responses,
			survey_id: surveyId,
			ts: ts,
			accountId: secAccId,
			secReturnId: secReturnId
		};
		if (orderId) payload.order_id = orderId;

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/survey'
			}),
			payload
		).then(
			json => {
				if (!initialResponse) {
					dispatch(surveySaveSuccessAction({ survey_id: surveyId, responses: responses }));
				}
			},
			err => {
				dispatch(surveySaveErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

function surveyCompleteRequestAction() {
	return { type: SURVEY_COMPLETE_REQUEST };
}

function surveyCompleteSuccessAction(data) {
	return { type: SURVEY_COMPLETE_SUCCESS, data };
}

function surveyCompleteErrorAction(error) {
	return { type: SURVEY_COMPLETE_ERROR, error };
}

export function completeSurveyAction({ surveyId, refId, orderId, secAccId, ts, secReturnId }) {
	return dispatch => {
		dispatch(surveyCompleteRequestAction());
		const payload = {
			channel: 'website',
			page: '1',
			platform: 'desktop',
			ref_id: refId,
			order_id: orderId,
			survey_id: surveyId,
			ts: ts,
			accountId: secAccId,
			secReturnId: secReturnId
		};
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/survey/page/complete'
			}),
			payload
		).then(
			json => dispatch(surveyCompleteSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(surveyCompleteErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
